import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_LISTA_EDITAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.editar'), data).then(res => {
                commit('setListaActiva', res.data.lista);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_PLACES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.places'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PATROCINADORES_EDITAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.patrocinadores.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PATROCINADORES_BORRAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.patrocinadores.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PATROCINADORES_CREAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.patrocinadores.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_EDITAR_MANAGER: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.editar.manager'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_LIBERAR_ASIENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.liberar.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_BLOQUEAR_ASIENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.bloquear.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_BLOQUEAR_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.bloquear.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_LISTADO_BLOQUEOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.listado-bloqueos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_LISTADO_OCUPACION: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.listado-ocupacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_LISTADO_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.listado-butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_LISTADO_BUTACAS_REGION: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.listado-butacas-region'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_REGIONES_ANEXAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.regiones-anexas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_TAQUILLA_REGIONES_ANEXAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.taquilla.regiones-anexas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_CUPONES_CARGAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.cupones.cargar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_ZONAS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.zonas.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_ZONAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    
    BACK_PRECIOS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_DESCUENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.descuentos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_DESCUENTOS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.descuentos.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_DESCUENTOS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.descuentos.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_DESCUENTOS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.descuentos.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_CARGAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.cargar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_INFORME_EMAILS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.informe.emails'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_INFORME_EMAILS_LISTADO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.informe.emails.listado'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PLAZOS_IMPAGADOS_ABONOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.plazos-impagados.abonos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PLAZOS_IMPAGADOS_BASES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.plazos-impagados.bases'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PLAZOS_IMPAGADOS_ENVIAR_AVISOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.plazos-impagados.enviar-avisos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PLAZOS_IMPAGADOS_ENVIAR_AVISO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.plazos-impagados.enviar-aviso'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_PLAZOS_DESCARGAR_EXCEL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.plazos.descargar-excel'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_STORE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.store'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_REGIONES_DISPONIBLES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.regiones.disponibles'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_PRECIOS_DISPONIBLES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.precios.disponibles'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_EDIT : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.edit'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_VOUCHERS_REGIONES_ASIGNAR_CODIGOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.vouchers.regiones.asignar.codigos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_CREAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_EDITAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_BORRAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.borrar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_DESCUENTOS_DISPONIBLES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.descuentos.disponibles'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_ADD_PRICES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.add.prices'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_GRUPOS_DESCUENTOS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.grupos.descuentos.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_SETTINGS_RECINTO_BUTACAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.settings.recinto.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_LISTA_SETTINGS_RECINTO_BUTACAS_GUARDAR_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.settings.recinto.butacas.guardar.precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_FORMS_CAMPOS_PERSONALIZADOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.forms.campos-personalizados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_FORMS_CAMPOS_PERSONALIZADOS_ADD : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.forms.campos-personalizados.add'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_FORMS_CAMPOS_PERSONALIZADOS_DELETE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.forms.campos-personalizados.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }, 
    BACK_LISTA_ABONADOS_RENOVACION: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.lista.abonados.renovacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_CALCULAR_PLAZOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.calcular.plazos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_BLOQUEAR_PARCELAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.bloquear-parcelas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_TAQUILLA_RECINTO_SECCIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.taquilla.recinto.secciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_TAQUILLA_RECINTO_SECCIONES_SVG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.taquilla.recinto.secciones.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_TAQUILLA_RECINTO_SECCIONES_REGIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.taquilla.recinto.secciones.regiones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_TAQUILLA_RECINTO_SECCIONES_REGIONES_SVG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.taquilla.recinto.secciones.regiones.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_PRECIOS_SIN_RECINTO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.precios.sin-recinto'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_SIN_RECINTO_BLOQUEAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.sin-recinto.bloquear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_SIN_RECINTO_ALTA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.sin-recinto.alta'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    BACK_ABONO_ONLINE_PARCELA_VINCULAR: function({commit}, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abono.online.parcela.vincular'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_LISTA_INVITACIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.lista.invitaciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONADOS_LISTA_INVITACIONES_ACTUALIZAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonados.lista.invitaciones-actualizar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};
